<!-- date filter -->
<div *ngIf="showChart">
	<div class="row col-12">
		<h1 class="h3 m-4">{{title}} <app-help-tooltip *ngIf="tooltipText" [field]="tooltipText"></app-help-tooltip></h1>
	</div>

	<div class="row col-xl-12 mb-4" *ngIf="!userParentFilters">
		<div class="col-xl-4 col-md-4">
			<div class="input-group">
				<div class="input-group-prepend">
					<span class="input-group-text">{{'g.start_date' | translate}}</span>
				</div>
				<input type="text" class="form-control" placeholder="mm/dd/yyyy" name="dp1" (ngModelChange)="changeDate('fromDate', $event)" [(ngModel)]="fromDate" bsDatepicker #d1="bsDatepicker" [bsConfig]="{containerClass: 'theme-dark-blue'}" [maxDate]="toDate" [minDate]="siteInstallationDate">
				<div class="input-group-append pointer" (click)="d1.toggle()">
					<span class="input-group-text"><i class="fa fa-calendar"></i></span>
				</div>
			</div>
		</div>

		<div class="col-xl-4 col-md-4">
			<div class="input-group">
				<div class="input-group-prepend">
					<span class="input-group-text">{{'g.end_date' | translate}}</span>
				</div>
				<input type="text" class="form-control" placeholder="mm/dd/yyyy" name="dp2" (ngModelChange)="changeDate('toDate', $event)" [(ngModel)]="toDate" bsDatepicker #d2="bsDatepicker" [bsConfig]="{containerClass: 'theme-dark-blue'}" [minDate]="fromDate">
				<div class="input-group-append pointer" (click)="d2.toggle()">
					<span class="input-group-text"><i class="fa fa-calendar"></i></span>
				</div>
			</div>
		</div>

		<!-- truck type filter -->
		<div class="col-xl-3 col-md-4">
			<ng-select
				*ngIf="hasTruckTypeFilter"
				class="select"
				[items]="truckTypes"
				[addTag]="false"
				[clearable]="false"
				[searchable]="false"
				bindLabel="label"
				bindValue="value"
				(change)="onSelectionChanged({filter: 'truckType', value: $event.value})"
				[placeholder]="'g.type' | translate"
				[(ngModel)]="selectedTruckType"
			></ng-select>
		</div>
	</div>

	<div class="row col-xl-12 mb-4" *ngIf="!userParentFilters">
		<!-- voltage filter -->
		<div class="col-sm-6 col-md-4 col-lg-4" *ngIf="hasVoltageFilter">
			<label for="batteryVoltageSelect">{{"fleet_reports.battery_voltage" | translate}}</label>
			<ng-select
				id="batteryVoltageSelect"
				class="select"
				[items]="batteryVoltagesOptions"
				[addTag]="false"
				[clearable]="false"
				[searchable]="false"
				bindLabel="label"
				bindValue="value"
				(change)="onSelectionChanged({filter: 'voltageFilter', value: $event.value})"
				[placeholder]="'qv.voltage' | translate"
				[(ngModel)]="selectedBatteryVoltage"
			></ng-select>
		</div>

		<!-- capacity filter -->
		<div class="col-sm-6 col-md-4 col-lg-4" *ngIf="hasCapacityFilter">
			<label for="batteryCapacitySelect">{{"devices.battery_capacity" | translate}}</label>
			<ng-select
				id="batteryCapacitySelect"
				class="select"
				[items]="batteryCapacitiesOptions"
				[addTag]="false"
				[clearable]="false"
				[searchable]="false"
				bindLabel="label"
				bindValue="value"
				(change)="onSelectionChanged({filter: 'capacityFilter', value: $event.value})"
				[placeholder]="'qv.capacity' | translate"
				[(ngModel)]="selectedBatteryCapacity"
			></ng-select>
		</div>
	</div>

	<div>
		<!-- data length is checked too: some early returns leave noData untouched, and rendering a
		     chart with an empty data set makes the chart library report a column type error -->
		<div *ngIf="!noData && usedDevicesNumberChart.data.length; else noDataTemplet">
			<div class="mb-5 mt-5">
				<sct-charts
					class="chart"
					[id]="chart.firstChartTitle"
					[title]="chart.firstChartTitle"
					[data]="usedDevicesNumberChart.data"
					[columnNames]="usedDevicesNumberChart.columnNames"
					[options]="usedDevicesNumberChart.config"
					[type]="'ColumnChart'"
					[height]="200"
				></sct-charts>
			</div>

			<div class="mb-5 mt-5">
				<sct-charts
					class="chart"
					[id]="chart.secondChartTitle"
					[title]="chart.secondChartTitle"
					[data]="usagePercentageChart.data"
					[columnNames]="usagePercentageChart.columnNames"
					[options]="usagePercentageChart.config"
					[type]="'LineChart'"
					[height]="200"
				></sct-charts>
			</div>
		</div>
	</div>
</div>

<ng-template #noDataTemplet class="mt-4">
	<div class="card-body">
		<div class="alert alert-info">{{'g.no_data_to_show' | translate}}</div>
	</div>
</ng-template>
